// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../../../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  order: null,
  error: null,
};

const orderDetailsReducer = createReducer(initialState, {
  [types.ORDER_REQUEST](state, action) {
    return {
      ...state,
      data: action.data,
    };
  },
  [types.ORDER_REQUEST_SUCCESS](state, action) {
    return {
      ...state,
      order: action.response,
    };
  },
  [types.ORDER_REQUEST_FAILED](state, action) {
    return {
      ...state,
      error: action.error
    };
  },
  // eslint-disable-next-line no-unused-vars
  [types.ORDER_RESET](state, action) {
    return {
      ...initialState,
    };
  },
});

export default orderDetailsReducer;
